<template>
    <div aria-hidden="true">
        <loading-busy :loading="loading" :isAuthenticating="false" text=""></loading-busy>
        <div
            class="g-recaptcha"
            data-size="invisible"
            :data-sitekey="googleRecaptchaApiKey"
            :data-action="action"
            data-callback="recaptchaCallback"
        />
    </div>
  </template>
  
  <script>
  import nyApi from '@/api/nyApi';
  import loadingBusy from '@/components/LoadingBusy.vue';
  import { mapActions } from 'vuex';

  export default {
      components: {
        loadingBusy
      },
      props: {
        useNewAuthApi: {
            type: Boolean,
            default: false
        }
     },
      data() {
          const config = window.APP_CONFIG || {};
          return {
              googleRecaptchaApiKey: config.RECAPTCHA_KEY || process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
              googleRecaptchaApiUrl: config.RECAPTCHA_ENDPOINT || process.env.VUE_APP_GOOGLE_RECAPTCHA_ENDPOINT,
              action: 'login',
              loading: false,
              userName: '',
              userData:{},
              testSiteCode:''
          }
      },
      mounted() {
            // next line places reCAPTCHA callback in global scope
            // (outside of Vue) for Google reCAPTCHA API callback
            window.recaptchaCallback = this.recaptchaCallback;
            console.log(this.googleRecaptchaApiUrl);

            const recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', this.googleRecaptchaApiUrl);
            document.head.appendChild(recaptchaScript);
      },
      methods: {
        ...mapActions(['authenticate']),
          verifyRecaptcha(userData, testSiteCode) {
              this.testSiteCode = testSiteCode;
              this.userData = userData;
              // eslint-disable-next-line no-undef
              grecaptcha.enterprise.execute();
          },
          async recaptchaCallback(reCAPTCHAtoken) {
                console.log(reCAPTCHAtoken);
                let isValid = false;
                let res = null;
                try{

                    //If a test site code is provided, the backend reCAPTCHA validation will be bypassed.
                    if(this.testSiteCode && this.testSiteCode.length > 0) {
                        nyApi.SetTestSiteCode(this.testSiteCode);
                    } else {
                        nyApi.ClearTestSiteCode();
                    }

                    this.loading = true;

                    if (this.useNewAuthApi) {
                        res = await this.authenticate({user: this.userData, action: this.action, token: reCAPTCHAtoken});
                        
                        if(res && res.data.token){
                            isValid = true;
                            nyApi.SetAuthToken(res.data.token);
                        }
                    }
                    else  {
                        let token = await nyApi.Authenticate(this.userData, this.action, reCAPTCHAtoken);
                        if(token) {
                            isValid = true;
                            nyApi.SetAuthToken(token);
                        }
                    }
                }
                catch(error){
                    isValid = false;
                }
                finally{
                    this.loading = false;
                }                

                if(isValid) {
                    this.$emit("recaptchaValid", res);
                }  else {
                    this.$emit("recaptchaInvalid", res);
                }
          }
      }
  }
  </script>
  
  <style>
  
  </style>